<template>
    <v-row style="margin: 0; background: #ddd;padding:0 8px;">
        <div style="width:25px;" />
        <v-col>
            <p style="font-size: 1rem; margin: 0; color: #666;">
                Flight No.
            </p>
        </v-col>
        <v-col>
            <p style="font-size: 1rem; margin: 0; color: #666;">
                Leg
            </p>
        </v-col>
        <v-col>
            <p style="font-size: 1rem; margin: 0; color: #666;">
                Time / Slots
            </p>
        </v-col>
        <v-col>
            <p style="font-size: 1rem; margin: 0; color: #666;">
                Date
            </p>
        </v-col>
        <v-col>
            <p style="font-size: 1rem; margin: 0; color: #666;">
                Flight Type
            </p>
        </v-col>
    </v-row>
</template>

<script>

    export default {
        name: 'SelectedFlightListHeader',

        /* >>> *************************************************************** / /* Props */
        props: {}, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data() {

            return {};

        }, // eo data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
        created: function () {

            const me = this;


            me.$toc('>>> views/flights/flights/components/crud/SelectedFlightListHeader.vue >>> created');

        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
        destroyed: function () {

            const me = this;


            me.$toc('>>> views/flights/flights/components/crud/SelectedFlightListHeader.vue >>> destroyed');

        }, // eo function destroyed()



        /* >>> *************************************************************** / /* Methods */
        methods: {


        } // eo methods{}
        /* <<< ****************************************************************/
    };
</script>
